'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'oil-well';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e532';
var svgPathData = 'M538.8 224.1c6.9 25.6-8.3 51.9-33.9 58.8l-15.5 4.1-66.3-247.3 15.5-4.1c25.6-6.9 51.9 8.3 58.8 33.9l41.4 154.5zM528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l28.6 106.9-120.4 31.2-13.4-39.3c-2.2-6.5-8.3-10.8-15.1-10.8s-12.9 4.4-15.1 10.8l-19 55.6-141.9 36.8 0-63.2c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 304-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l544 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-159.1 0-1.8-5.2-70.3-205.9-31.1 8.1 28.3 83-108.2 0 23.3-68.4-37.1 9.6-59.3 173.6-1.8 5.2-47.1 0 0-207.8 333.2-86.4 29.3 109.5c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM337 392l30 88-190.2 0 30-88 130.1 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faOilWell = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;